import httpWrapper from '../HttpWrapper'
import { GetCompaniesReq } from './models/getCompanies/GetCompaniesReq'
import { GetCompaniesRes } from './models/getCompanies/GetCompaniesRes'
import { SearchCompaniesRes } from './models/search/SearchCompaniesRes'

class CompanyApi {
    private static instance: CompanyApi

    public constructor() {
        if (CompanyApi.instance) {
            return CompanyApi.instance
        }

        CompanyApi.instance = this
    }

    public async searchCompanies(
        searchTerm: string,
    ): Promise<SearchCompaniesRes> {
        const queryParams = new URLSearchParams({
            q: searchTerm,
        })

        return await httpWrapper.get<SearchCompaniesRes>(
            '/company/search',
            queryParams,
        )
    }

    public async getNumberOfCompanyNodes(): Promise<number> {
        return await httpWrapper.get<number>('/company/count')
    }

    public async getCompanies(data: GetCompaniesReq): Promise<GetCompaniesRes> {
        return await httpWrapper.post('/company/get-companies', data)
    }
}

const companyApi = new CompanyApi()
export default companyApi
